export const contactsRouteNames = {
  default: 'contacts-v2',
  smartList:'smart-list-v2',
  importFilter:'import_filter-v2',
  import:'imports',
  businessName:'business_name-v2',
  bulkActions:'bulk-actions-log-v2',
  contactDetail:'contact_detail-v2',
  contactRestore:'contact_restore-v2',
}
